export default __webpack_public_path__ + "assets/media/product-empty.f89d965e.png";